import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const STATUS = {
  APPROVED: ["Approved", "text-emerald-700"],
  PENDING: ["Waiting for Meta approval", "text-amber-700"],
  REJECTED: ["Rejected by Meta", "text-rose-600"],
};

export function OrderTemplateBox({ info, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (!info) return null;
  const [label, tone] = STATUS[info.status] || ["Not submitted yet", "text-muted-foreground"];
  const submit = async () => {
    setBusy(true);
    try { await api.post("/whatsapp/order-template/submit"); toast.success("Submitted to Meta. The app switches to it automatically once it's approved."); onChanged(); }
    catch (e) { toast.error(errMsg(e), { duration: 10000 }); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 rounded-xl border border-[#E7E2D6] p-3 text-sm" data-testid="order-template-box">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="font-semibold">6 PM order question - Utility version</div>
        <span className={`text-xs font-semibold ${tone}`} data-testid="order-template-status">{info.in_use ? "In use now" : label}</span>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">Meta limits Marketing messages. This Utility version ({info.name}) is about the member's own order, so Meta doesn't limit it the same way. Once it's approved, the 6 PM question switches to it automatically.</p>
      <p className="mt-2 rounded-lg bg-[#FAF4E8] p-2 text-xs" data-testid="order-template-body">{info.body}</p>
      {!info.status && (
        <Button size="sm" onClick={submit} disabled={busy} className="mt-2 rounded-full bg-[#0F382C] hover:bg-[#134E3A]" data-testid="order-template-submit-btn">
          {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Send className="mr-1 h-4 w-4" />}Submit to Meta for approval
        </Button>
      )}
    </div>
  );
}
